import { forbesRoutesOptions } from 'themes/partners/forbes/routes';

export const routesOptions = forbesRoutesOptions;
